import PropTypes from 'prop-types';
import TeamsPinnedFilterMultiSelect from '@splunk/olly-common/teams/TeamsPinnedFilterMultiSelect';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';

export default function TeamsFilter({ teamNames, onChange, selectedTeamNamesOverride }) {
    const themeKey = useLegacyThemeServiceKey();
    return (
        <ThemeProvider colorScheme={themeKey}>
            <TeamsPinnedFilterMultiSelect
                teamNames={teamNames}
                onChange={onChange}
                selectedTeamNamesOverride={selectedTeamNamesOverride}
            />
        </ThemeProvider>
    );
}

TeamsFilter.propTypes = {
    teamNames: PropTypes.array,
    onChange: PropTypes.func,
    selectedTeamNamesOverride: PropTypes.array,
};
